<mat-action-list>
    <div mat-subheader>Previous </div>
    <button mat-list-item *ngFor="let action of actionList | reverse; trackBy: trackByFn" (click)="selectItem(action.id)">
        <!-- <mat-icon mat-list-icon>folder</mat-icon> -->
        <div mat-line><span class="description">{{action.description}}</span></div>
        <div mat-line *ngIf="action.description !== action.id"><span class="orderText">{{action.id}}</span></div>
    </button>
</mat-action-list>